"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Lead Submission
 * Lead Submission Microservice
 *
 * OpenAPI spec version: 0.1.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var url = require("url");
var portableFetch = require("portable-fetch");
var BASE_PATH = "https://service-lead-submission.sm360.ca".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
/**
 * AttachmentApi - fetch parameter creator
 * @export
 */
exports.AttachmentApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file', 'Required parameter file was null or undefined when calling upload.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId', 'Required parameter organizationId was null or undefined when calling upload.');
            }
            var localVarPath = "/upload";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            // authentication oidc required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oidc", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (file !== undefined) {
                localVarFormParams.set('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AttachmentApi - functional programming interface
 * @export
 */
exports.AttachmentApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            var localVarFetchArgs = exports.AttachmentApiFetchParamCreator(configuration).upload(file, organizationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AttachmentApi - factory interface
 * @export
 */
exports.AttachmentApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            return exports.AttachmentApiFp(configuration).upload(file, organizationId, options)(fetch, basePath);
        },
    };
};
/**
 * AttachmentApi - object-oriented interface
 * @export
 * @class AttachmentApi
 * @extends {BaseAPI}
 */
var AttachmentApi = /** @class */ (function (_super) {
    __extends(AttachmentApi, _super);
    function AttachmentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Upload file to attach later on lead submission
     * @param {any} file File to upload
     * @param {number} organizationId Id of the organization in which the Lead is submitted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    AttachmentApi.prototype.upload = function (file, organizationId, options) {
        return exports.AttachmentApiFp(this.configuration).upload(file, organizationId, options)(this.fetch, this.basePath);
    };
    return AttachmentApi;
}(BaseAPI));
exports.AttachmentApi = AttachmentApi;
/**
 * LeadApi - fetch parameter creator
 * @export
 */
exports.LeadApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'leadSubmissionRequest' is not null or undefined
            if (leadSubmissionRequest === null || leadSubmissionRequest === undefined) {
                throw new RequiredError('leadSubmissionRequest', 'Required parameter leadSubmissionRequest was null or undefined when calling send.');
            }
            var localVarPath = "/send";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oidc required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oidc", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LeadSubmissionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(leadSubmissionRequest || {}) : (leadSubmissionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadApi - functional programming interface
 * @export
 */
exports.LeadApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            var localVarFetchArgs = exports.LeadApiFetchParamCreator(configuration).send(leadSubmissionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * LeadApi - factory interface
 * @export
 */
exports.LeadApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            return exports.LeadApiFp(configuration).send(leadSubmissionRequest, options)(fetch, basePath);
        },
    };
};
/**
 * LeadApi - object-oriented interface
 * @export
 * @class LeadApi
 * @extends {BaseAPI}
 */
var LeadApi = /** @class */ (function (_super) {
    __extends(LeadApi, _super);
    function LeadApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Submit a new lead
     * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.send = function (leadSubmissionRequest, options) {
        return exports.LeadApiFp(this.configuration).send(leadSubmissionRequest, options)(this.fetch, this.basePath);
    };
    return LeadApi;
}(BaseAPI));
exports.LeadApi = LeadApi;
